<div class="main">
  @if (selectedSubscription !== null) {
  <div class="subscriptions-breadcrumb">
    <f-breadcrumb divider=">" [breadcrumbItems]="items" (breadcrumbSelected)="onBreadcrumbSelected($event)">
    </f-breadcrumb>
  </div>

  <h1>{{ selectedSubscription.subscriptionName || selectedSubscription.title }}</h1>
  @if (selectedSubscription.title) {
    <div>
      <span class="subscription-title-label">Title: {{ selectedSubscription.title }}</span>
    </div>
  }

  <p class="subscriptions-version-label">{{reports.length}} items</p>

  <div class="subscriptions-version-table run-table">
    <f-table auto-sort>
      <table role="table" aria-colcount="4">
        <caption class="screen-reader-text">
          This is a table containing all versions of the selected subscription.
        </caption>
        <thead>
          <tr role="row">
            <th data-type="string" class="text-align-left w-15" role="columnheader">
              Version Name
            </th>
            <th data-type="string" data-sortable class="text-align-left" role="columnheader">
              Creation Time [US Central]
            </th>
            <th data-type="string" data-sortable class="text-align-left" role="columnheader">
              Status
            </th>
            <th data-type="string" data-sortable class="text-align-left" role="columnheader">
              Download
            </th>
          </tr>
        </thead>
        <tbody>
          @for (report of reports; track report) {
          @let run = report | runStatus;
          <tr role="row">
            <td role="cell" class="text-wrap-nowrap">
              {{report.version}}
            </td>
            <td role="cell" class="text-align-left">
              {{ formatTimestamp(report.endDttm || report.startDttm) }}
            </td>
            <td role="cell" class="text-align-left">
              <span class="run-status" [ngClass]="'run-status--' + run.tone" [attr.title]="run.hint">
                <span class="run-status__icon" aria-hidden="true">{{ run.icon }}</span>
                {{ run.label }}
              </span>
              @if (run.status === 'FAILED' && run.detail) {
              <span class="run-status__detail">{{ run.detail }}</span>
              }
            </td>
            <td role="cell" class="text-align-left">
              @if (run.hasFile) {
                <a (click)="onDownloadClick(report.storageURL)">Download</a>
              } @else if (run.status === 'RUNNING') {
                <span class="run-file-pending">Not ready yet</span>
              } @else {
                <span class="run-file-pending">No file</span>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </f-table>
  </div>
  }
</div>